import moment from 'moment'

import type { AnalyticsCorrelationService } from '../analytics-correlation.service'

import { app } from '../../../app.module'

export interface CorrelationFilter {
  categoryName: string
  subCategoryName: string
  accountTagFilter: string[]
  followerRangeFilter: string[]
  accountGlobalFilter: number
  startEndDate: {
    startDate: number
    endDate: number
  }
}

/**
 * 相関グラフフィルター
 * @class AnalyticsCorrelationFilterCtrl
 */
class AnalyticsCorrelationFilterCtrl {
  // SNSタイプ
  private snsType: string
  // フィルター
  private filter: CorrelationFilter
  // フィルター変更イコールバック
  private onChangeFilter: Function
  private accountTagList: any

  constructor(
    $scope: ng.IScope,
    private AnalyticsCorrelationService: AnalyticsCorrelationService
  ) {
    this.filter = {
      categoryName: null,
      subCategoryName: null,
      accountTagFilter: null,
      followerRangeFilter: null,
      accountGlobalFilter: null,
      startEndDate: null,
    }
    // カテゴリー変更のイベントをwatchする
    $scope.$on('changeBrandCategory', this.changeBrandCategory)
    // フィルタ変更のイベントをwatchする
    $scope.$on('changeFilterData', this.changeSubCategory)
    // 期間変更のイベントをwatchする
    $scope.$on('changeDateRange', this.changeDateRange)
  }

  /**
   * 初期化
   * @private
   * @return {void}
   */
  public $onInit(): void {
    this.filter.startEndDate = {
      startDate: moment(moment().subtract(31, 'days').format('YYYY-MM-DD 00:00:00')).unix(),
      endDate: moment(moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00')).unix(),
    }
  }

  /**
   * アカウントタグフィルターの変更
   * @param {string[]} selectedTags 選択したタグリスト
   */
  public changeSelectedAccountTags(selectedTags: string[]) {
    this.filter.accountTagFilter = selectedTags
    this.changeFilter()
  }

  /**
   * フォロワー数範囲フィルターの変更
   * @param {string[]} followerRange フォロワー数範囲
   */
  public changeFollowerFilter(followerRange: string[]) {
    if (this.filter.followerRangeFilter === followerRange) {
      return
    }
    this.filter.followerRangeFilter = followerRange
    this.changeFilter()
  }

  /**
   * アカウントグローバルフィルターの変更
   * @param {number} accountGlobal アカウントグローバル
   */
  public changeAccountGlobalFilter(accountGlobal: number) {
    if (this.filter.accountGlobalFilter === accountGlobal) {
      return
    }
    this.filter.accountGlobalFilter = accountGlobal
    this.changeFilter()
  }

  /**
   * ブランドカテゴリの変更イベント
   * @private
   * @param {any} event イベント
   * @param {{type: string, categoryName: string}} categoryInfo カテゴリ情報
   */
  private changeBrandCategory = (
    event,
    categoryInfo: { type: string; categoryName: string; subCategoryName: string }
  ): void => {
    if (!categoryInfo || categoryInfo.type !== 'analytics-correlation') {
      return
    }
    this.filter.categoryName = categoryInfo.categoryName
    this.filter.subCategoryName = categoryInfo.subCategoryName
    // フィルターを変更する
    this.changeFilter()
  }

  /**
   * サブブランドカテゴリの変更イベント
   * @private
   * @param {any} event イベント
   * @param {{ type: string; subCategoryType: string; value: string }} filterInfo フィルター情報
   */
  private changeSubCategory = (
    event,
    filterInfo: { type: string; subCategoryType: string; value: string }
  ): void => {
    if (
      !filterInfo ||
      filterInfo.type !== 'subCategoryFilter' ||
      filterInfo.subCategoryType !== 'analytics-correlation'
    ) {
      return
    }
    this.filter.subCategoryName = filterInfo.value
    // フィルターを変更する
    this.changeFilter()
  }

  /**
   * 期間変更のイベント
   * @private
   * @return {void}
   */
  private changeDateRange = (event, startEndDate: { startDate: number; endDate: number }): void => {
    if (!startEndDate || !startEndDate.startDate || !startEndDate.endDate) {
      return
    }
    if (
      this.filter.startEndDate.startDate === startEndDate.startDate &&
      this.filter.startEndDate.endDate === startEndDate.endDate
    ) {
      return
    }
    this.filter.startEndDate = startEndDate
    // フィルターを変更する
    this.changeFilter()
  }

  /**
   * フィルターの変更
   */
  private changeFilter() {
    if (typeof this.onChangeFilter === 'function') {
      this.onChangeFilter({ filter: this.filter })
    }
  }
}

app.component('analyticsCorrelationFilter', {
  bindings: {
    snsType: '<',
    onChangeFilter: '&',
  },
  template: require('./analytics-correlation-filter.pug')(),
  controller: AnalyticsCorrelationFilterCtrl,
})
